import { isOwner } from '../state-manager.js';

function logoutUser() {
  fetch('/api/auth/logout', {
    method: 'POST',
    credentials: 'include'
  })
  .then(response => {
    if (response.ok) {
      console.log('[Auth] User logged out successfully');
      location.reload();
    } else {
      console.error('[Auth] Logout failed');
    }
  });
}

export function canEdit() {
  if (isOwner()) return true;
}

export function resetApp() {
  // Perform logout and clear state and cache
  logoutUser();
  localStorage.clear();
  const CACHE_NAME = 'samapp-cache-v2';
  caches.delete(CACHE_NAME);
  console.log('[Auth] Application state reset');
}
